package com.iregained.eventapp.components.models

import kotlinx.serialization.Serializable

@Serializable
data class EventDetailsData(
    val eventId: String = "",
    val title: String = "",
    val country: String = "",
    val countryCode: String = "",
    val city: String = "",
    val venueName: String = "",
    val timezone: String = "",
    val slug: String = "",
    val status: String = "",
    val defaultSlotDurationMinutes: Int = 60,
    val defaultSlotCapacity: Int = 16,
    val operatingSchedule: List<OperatingDayData> = listOf()
)